/**
 * Generated from syncly-creator-spec/open-api/campaign.openapi.yaml by scripts/openapi-converter.
 * Do not edit this file directly.
 */

import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';

export const deleteCampaignAnalysisPathSchema = z.object({
  campaignId: z.string(),
  runId: z.string(),
});

export type DeleteCampaignAnalysisInput = {
  path: z.input<typeof deleteCampaignAnalysisPathSchema>;
  signal?: AbortSignal;
};

export async function deleteCampaignAnalysis({
  path,
  signal,
}: DeleteCampaignAnalysisInput): Promise<void> {
  const parsedPath = deleteCampaignAnalysisPathSchema.parse(path);

  await socialApiClient.delete(
    `campaigns/${parsedPath.campaignId}/analyses/${parsedPath.runId}`,
    {
      signal,
    },
  );
}
